import { z } from 'zod';

export const markOrderAsPickedUpReqDto = z.object({
  orderId: z.string(),
});
export type MarkOrderAsPickedUpReqDto = z.infer<
  typeof markOrderAsPickedUpReqDto
>;
